var map = {
	"./platform001.png": 742769,
	"./platform002.png": 427431,
	"./platform003.png": 706995,
	"./platform004.png": 107385,
	"./platform005.png": 852782,
	"./platform006.png": 566631,
	"./platform007.png": 440494,
	"./platform008.png": 153490,
	"./platform009.png": 80500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473361;